import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopinOneComponent} from '../popin-one/popin-one.component';
import {NotificationService} from '../services/notification.service';
import {Data} from '../providers/data.provider';
import {DatasaveService} from '../services/datasave.service';
import {PopinVisit} from '../models/popinvisit.model';
import {MailSent} from '../models/mailsent.model';

@Component({
  selector: 'app-visitor-redirect',
  templateUrl: './visitor-redirect.component.html',
  styleUrls: ['./visitor-redirect.component.scss']
})
export class VisitorRedirectComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private notifService: NotificationService,
              private datasaveService: DatasaveService,
              private data: Data) {}
  public redirect = {
    type: 'redirect',
    url: this.route.snapshot.params['url']
  };
  public id: number;
  public link: string;
  public dest: any;
  public exped: any;
  public popinvisit: PopinVisit;
  public mailsent: MailSent;

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    this.link = this.route.snapshot.params['url'];
    this.dest = this.data.storage.huntingManager;

    this.exped = {
      'company': PopinOneComponent.customer,
      'visitorContent': this.link,
      'website': this.data.storage.website
    };

    this.mailsent = {
      popin: PopinOneComponent.popinId,
      mailType: PopinOneComponent.MAILTYPE_INTERETCONTENUPROSPECT,
      recipient: this.dest['_id']
    };

    this.popinvisit = {
      popin: PopinOneComponent.popinId,
      companyIdentifier: PopinOneComponent.customer['SIREN'],
      isCustomer: PopinOneComponent.isCustomer,
      visitType: PopinOneComponent.VISITTYPE_INTERETCONTENU,
      product: null,
      visitRandomId: PopinOneComponent.visitRandomId,
      visitorContent: this.link
    };

    this.notifService.sendProspectNotificationToManager(this.dest, this.exped)
      .then(() => {
        this.datasaveService.saveMailData(this.mailsent);
        this.datasaveService.saveVisitData(this.popinvisit);
        setTimeout(() => {
          this.sendEventToParent();
        }, 3000);
      })
      .catch(error => {
        console.log(error);
      });
  }

  redirectOnClick() {
    window.parent.postMessage(this.redirect, PopinOneComponent.uri);
  }

  sendEventToParent() {
    window.parent.postMessage(this.redirect, PopinOneComponent.uri);
  }

}
